//@ts-nocheck
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
// @ts-ignore
import * as Validator from 'validatorjs';
import TextInput from '../TextInput';
import { Title3 } from '../Typography';
import { about } from '../AboutCompany/index';
import styles from './styles.module.scss';
import { contactPersonInst } from '.';

const Step2 = observer(() => {
  const contact = about.values.contacts.find((item) => item.type === 'contact');

  const rules = {
    first_name: 'required',
    last_name: 'required',
    position: 'required',
    email: 'required|email',
    contact_phone: [
      'required',
      'regex:/^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,8}$/',
    ],
  };

  const validation = useMemo(
    () =>
      new Validator(
        {
          first_name: contact?.first_name,
          last_name: contact?.last_name,
          position: contact?.position,
          email: contact?.email,
          contact_phone: contact?.contact_phone,
        },
        rules,
        {
          required: 'This field is required',
          email: 'The email format is invalid',
          digits_between: 'Field should contain from 10 up to 14 digits only',
          'regex.contact_phone': 'Phone number with country code',
        },
      ),
    [
      contact?.first_name,
      contact?.last_name,
      contact?.position,
      contact?.email,
      contact?.contact_phone,
    ],
  );
  const isValid = validation.passes();

  // Устанавливаем валидацию при каждом изменении
  useEffect(() => {
    about.isPersonalDataValid = isValid;
    contactPersonInst.isStepIsValid[2] = isValid;
  }, [isValid]);

  useEffect(() => {
    const currentSigner = about.values.contacts.find(
      (item) => item.type === 'signer',
    );
    const currentContact = about.values.contacts.find(
      (item) => item.type === 'contact',
    );
    const currentSignerIndx = about.values.contacts.indexOf(currentSigner);
    const currentContactIndx = about.values.contacts.indexOf(currentContact);

    // Инициализация только при первом создании (не при редактировании)
    if (
      !contactPersonInst.isDataSended &&
      contactPersonInst.values.step1Variant
    ) {
      // надо заполнить данными из подписанта если он есть
      if (contactPersonInst.values.step1Variant === 'yes') {
        if (currentSignerIndx > -1) {
          if (!contactPersonInst.hasContact) {
            const firstName = currentSigner?.first_name?.trim() || '';
            const lastName = currentSigner?.last_name?.trim() || '';
            const fullName = `${firstName} ${lastName}`.trim();

            about.values.contacts.push({
              type: 'contact',
              full_name: fullName,
              first_name: currentSigner?.first_name,
              last_name: currentSigner?.last_name,
              email: currentSigner?.email,
              contact_phone: currentSigner?.contact_phone,
              position: currentSigner?.position,
            });
          }
        }
      } else {
        // создаем пустой контакт если выбрали "no" и его еще нет
        if (!contactPersonInst.hasContact) {
          about.values.contacts.push({
            type: 'contact',
            full_name: '',
            first_name: '',
            last_name: '',
            email: '',
            contact_phone: '',
            position: '',
          });
        }
      }
    }
    // При редактировании контакт уже существует и данные загружены
  }, [contactPersonInst.values.step1Variant]);

  // Автоматическое обновление full_name при изменении first_name или last_name
  useEffect(() => {
    if (contact && (contact.first_name || contact.last_name)) {
      const firstName = contact.first_name?.trim() || '';
      const lastName = contact.last_name?.trim() || '';
      contact.full_name = `${firstName} ${lastName}`.trim();
    }
  }, [contact?.first_name, contact?.last_name]);

  if (!contact) return null;

  return (
    <div className={styles.container}>
      <div>
        <Title3 className={styles.subTitle}>
          Please provide information about the main contact of your company*
        </Title3>
        <TextInput
          onChange={(e) => {
            contact.first_name = e;
          }}
          label="First name*"
          dataTest="firstName"
          className={styles.textField}
          value={contact?.first_name}
          error={validation.errors.first('first_name')}
        />
        <TextInput
          onChange={(e) => {
            contact.last_name = e;
          }}
          label="Last name*"
          dataTest="lastName"
          className={styles.textField}
          value={contact?.last_name}
          error={validation.errors.first('last_name')}
        />

        <TextInput
          onChange={(e) => {
            contact.position = e;
          }}
          label="Position*"
          dataTest="position"
          className={styles.textField}
          value={contact?.position}
          error={validation.errors.first('position')}
        />

        <TextInput
          onChange={(e) => {
            contact.email = e;
          }}
          label="Email*"
          dataTest="email"
          className={styles.textField}
          value={contact?.email}
          error={validation.errors.first('email')}
        />

        <TextInput
          onChange={(e) => {
            contact.contact_phone = e;
          }}
          label="Phone number*"
          dataTest="phone"
          className={styles.textField}
          value={contact?.contact_phone}
          error={validation.errors.first('contact_phone')}
        />
      </div>
    </div>
  );
});

export default Step2;
